module.exports = __webpack_public_path__ + "img/module_video.11c8f1ef.jpg";